import { IKB } from "../../models/kb.model";

export const FakeKnowledgeBase: IKB[] = [
  {
    "name": "Central Knowledge Repository",
    "vectorStore": "MongoDB",
    "description": "A unified repository for storing and indexing essential resources, providing semantic search capabilities and quick access to critical data across multiple domains.",
    "connectionString": "mongodb+srv://username:password@database.mongodb.net/",
    "indexName": "central-knowledge-index",
    "database": "knowledge_repository",
    "collection": "resources",
    "contentField": "content",
    "searchType": "semantic",
    "logo": "/assets/images/central-knowledge-logo.png"
  }
];
